import React, { useState } from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import { apiUrl } from "../../utils/api";
import styles from "./Company.module.css";

const inquiryOptions = ["Sales", "Partnership", "Services", "Others"];

const emptyForm = {
  name: "",
  email: "",
  phone: "",
  company: "",
  inquiryType: "",
  message: "",
};

const CompanyContactForm = () => {
  const [form, setForm] = useState(emptyForm);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const updateField = (field) => (event) => {
    setForm((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const response = await fetch(apiUrl("/api/contacts"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name.trim(),
          email: form.email.trim(),
          phone: form.phone.trim(),
          company: form.company.trim(),
          inquiryType: form.inquiryType,
          message: form.message.trim(),
        }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data.error || "Could not send your message.");
      }
      setSuccess(true);
      setForm(emptyForm);
    } catch (err) {
      setError(err.message || "Could not send your message.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.contactFormCard}>
      <h2>Contact us</h2>
      <p className={styles.contactFormIntro}>
        Share a few details and our team will follow up with you.
      </p>
      {success ? (
        <p className={styles.contactSuccess}>
          Thank you. Your message has been received.
        </p>
      ) : null}
      <Form onSubmit={handleSubmit}>
        <div className={styles.contactFormGrid}>
          <Form.Group className="mb-3">
            <Form.Label>Name*</Form.Label>
            <Form.Control
              value={form.name}
              onChange={updateField("name")}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email*</Form.Label>
            <Form.Control
              type="email"
              value={form.email}
              onChange={updateField("email")}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Contact number*</Form.Label>
            <Form.Control
              value={form.phone}
              onChange={updateField("phone")}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Company</Form.Label>
            <Form.Control
              value={form.company}
              onChange={updateField("company")}
            />
          </Form.Group>
        </div>
        <Form.Group className="mb-3">
          <Form.Label>I am enquiring about*</Form.Label>
          <div className={styles.inquiryOptions}>
            {inquiryOptions.map((option) => (
              <Form.Check
                key={option}
                inline
                type="radio"
                id={`inquiry-${option.toLowerCase()}`}
                name="inquiryType"
                label={option}
                value={option}
                checked={form.inquiryType === option}
                onChange={updateField("inquiryType")}
                required
              />
            ))}
          </div>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Message*</Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            value={form.message}
            onChange={updateField("message")}
            required
          />
        </Form.Group>
        {error ? <p className={styles.contactError}>{error}</p> : null}
        <Button className={styles.contactSubmit} type="submit" disabled={submitting}>
          {submitting ? (
            <>
              <Spinner animation="border" size="sm" /> Sending
            </>
          ) : (
            "Send message"
          )}
        </Button>
      </Form>
    </div>
  );
};

export default CompanyContactForm;
